import { useContext } from 'react';

import { RowsPerPageContext, SetRowsPerPageContext, GetRowsPerPageContext} from '../context';

export const useRowsPerPage = () => useContext(RowsPerPageContext)!;
export const useSetRowsPerPage = () => useContext(SetRowsPerPageContext)!;
export const useGetRowsPerPage = () => useContext(GetRowsPerPageContext)!;